export const CONFIGURATION_EDITOR_MESSAGES = {
  SUCCESS: "Configuration updated successfully",
  ERROR: "Failed to update configuration. Please try again.",
  INVALID_JSON: "Invalid JSON format. Please check your input.",
  INVALID_FILE: "Could not read the file. Make sure it is a valid configuration JSON.",
  UPLOAD_SUCCESS: "File loaded. Review and click Save changes to apply.",
  INVALID_CONFIG_FORMAT: "The configuration format is invalid. Please review your changes and try again.",
};

export const CONFIGURATION_EDITOR_LABELS = {
  DESCRIPTION: "View the configuration file.",
  JSON_CONFIGURATION: "Configuration Editor",
  JSON_DESCRIPTION: "View the JSON content for the configuration",
  JSON_PLACEHOLDER: "Enter JSON here",
  INVALID_JSON: "Invalid JSON format",
  JSON_INPUT_TITLE: "JSON Input",
  DOWNLOAD: "Download",
  UPLOAD: "Upload file",
  UPLOADED_FILE: "Loaded from file",
  SAVE: "Save changes",
  TOO_LARGE: "The configuration is too large to display (over 5 MB). Use the Download button to view it.",
};

export const MAX_CONFIGURATION_SIZE_BYTES = 5 * 1024 * 1024;

